import { ThreatenContent } from '@/components/ThreatenContent/ThreatenContent'
import { WarnemContent } from '@/components/WarnemContent/WarnemContent'
import { DashboardExperiments } from '@/experiments'
import { useFlag } from '@/hooks/useFlag'
import { usePremiumFeaturesPaymentIssue } from '@/stores/permissions/premiumFeatures'
import { colors } from '@/styles/colors'
import { Modal } from 'antd'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

export function usePaymentStatusWarnings() {
  const { t: tUtils } = useTranslation(undefined, { keyPrefix: 'utils' })
  const { t } = useTranslation()
  const ref = useRef<boolean>(false)

  const shouldEnforceBillingFoundations = useFlag(
    DashboardExperiments.shouldEnforceBillingFoundations,
  )

  const premiumFeaturesPaymentIssue = usePremiumFeaturesPaymentIssue()

  const shouldWarn = premiumFeaturesPaymentIssue?.shouldWarn
  const shouldThreat = premiumFeaturesPaymentIssue?.shouldThreat
  const gracePeriod = premiumFeaturesPaymentIssue?.gracePeriod

  useEffect(() => {
    if (ref.current) {
      return
    }

    if (shouldEnforceBillingFoundations && premiumFeaturesPaymentIssue) {
      ref.current = true

      if (shouldWarn) {
        Modal.confirm({
          centered: true,
          okButtonProps: {
            style: {
              backgroundColor: colors.primary,
              color: colors.white,
            },
          },
          title: t(`components.modals.paymentStatusWarnings.warnem.title`),
          content: <WarnemContent gracePeriod={gracePeriod} />,
          okText: t(`components.modals.paymentStatusWarnings.okText`),
          onOk: () => {
            window.open(t(`pages.accountSuspended.billingAddress`), '_blank')
          },
        })
      }

      if (shouldThreat)
        Modal.error({
          centered: true,
          okButtonProps: {
            style: {
              backgroundColor: colors.danger,
              color: colors.white,
            },
          },
          autoFocusButton: null,
          title: t(`components.modals.paymentStatusWarnings.threaten.title`),
          content: <ThreatenContent gracePeriod={gracePeriod} />,
          okText: t(`components.modals.paymentStatusWarnings.okText`),
          onOk: () => {
            window.open(t(`pages.accountSuspended.billingAddress`), '_blank')
          },
        })
    }
  }, [
    gracePeriod,
    shouldThreat,
    shouldWarn,
    premiumFeaturesPaymentIssue,
    t,
    tUtils,
    shouldEnforceBillingFoundations,
  ])
}
